const _excluded = ["children", "skin", "size", "rounded", "outlined", "className", "as"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import cn from 'classnames';
import styles from "./Badge.module.scss";
import { Typography } from "../Typography";
const skinToTypographyMap = {
  default: 'secondary',
  error: 'error',
  success: 'success',
  warning: 'warning',
  primary: 'primary'
};
export const Badge = /*#__PURE__*/React.forwardRef(function Badge(props, ref) {
  const {
    children,
    skin = 'default',
    size = 'default',
    rounded = false,
    outlined = false,
    className,
    as
  } = props,
        rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/React.createElement(Typography, _extends({}, rest, {
    ref: ref,
    className: cn(styles.root, className, styles[skin], styles[size], {
      [styles.outlined]: outlined,
      [styles.rounded]: rounded
    }),
    as: as,
    variant: "paragraph2",
    skin: skinToTypographyMap[skin]
  }), children);
});